import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChildren,
  QueryList,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { merge, Observable } from 'rxjs';
import { StepProgressStepComponent } from './step/step.component';

@UntilDestroy()
@Component({
  selector: 'app-step-progress',
  templateUrl: './step-progress.component.html',
  styleUrls: ['./step-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StepProgressComponent implements AfterViewInit {
  @ContentChildren(StepProgressStepComponent, { descendants: true })
  steps: QueryList<StepProgressStepComponent>;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit() {
    this.updateStepsCompletedStates();

    const stepsActiveChanges = merge(
      ...this.steps.map((step: StepProgressStepComponent) => step.activeChanged)
    ) as Observable<any>;
    stepsActiveChanges
      .pipe(untilDestroyed(this))
      .subscribe(() => this.updateStepsCompletedStates());
  }

  private updateStepsCompletedStates() {
    const stepsArr = this.steps.toArray();
    const lastActiveIndex = stepsArr
      .map((step: StepProgressStepComponent) => !!step.active)
      .lastIndexOf(true);

    setTimeout(() => {
      stepsArr.map((step: StepProgressStepComponent, index: number) => {
        step.completed = index <= lastActiveIndex;
        step.nextCompleted = index < lastActiveIndex;
      });
      this.cdRef.markForCheck();
    });
  }
}
